import React, {
  FC,
  useState,
  CSSProperties,
  memo,
  useCallback,
  useRef,
  useEffect,
} from 'react';
import Node from '../PitModule/treeStore.js';
import TreeJson from '../PitModule/treeJson';
import styles from '../../styles/tree.module.scss';
import PitCheckbox from '../PitCheckbox/PitCheckbox';
import PitSearchInput from '../PitSearchInput/PitSearchInput';
type PitModuleTreeProps = {
  itemSize?: number;
  indent?: number;
  style?: CSSProperties;
};
type baseType = string | number | boolean;
type propBaseType = string | number | null;
interface TreeDataProps {
  Id: string | number;
  level: number;
  hasChildren: propBaseType;
  expanded: propBaseType;
  loadStatus: propBaseType;
  checked: boolean | string;
  isCheckbox: propBaseType;
  indeterminate: boolean;
  text: string | undefined;
}
const PitModuleTree: FC<PitModuleTreeProps> = memo(
  ({ itemSize = 22, indent = 18 }) => {
    let [tabs] = useState(['构建', '空间']);
    let [active, setActive] = useState(0);
    let [treeData, setTreeData] = useState<TreeDataProps[]>([]);
    const computedTreeStruct = useCallback(() => {
      const store: any = new Node({
        data: JSON.parse(JSON.stringify(TreeJson)),
        props: {
          children: 'Children',
          label: 'DisplayName',
          disabled: 'disabled',
          checked: 'checked',
          isShow: 'isShow',
        },
      });
      console.log(store, 'store');
      setTreeData(() => [...store.data]);
    }, []);
    useEffect(() => {
      computedTreeStruct();
      if (tabs.length > 0) {
        const width = tabs[0].length * 35;
        sliderAnimate.current.style.width = width + 'px';
        sliderAnimate.current.style.left = '0';
      }
    }, []);
    const handleTabClick = useCallback(
      (index: number) => {
        setActive(index);
        console.log(index);
        const ele = giftsMapRef.current['tab-item' + index];
        sliderAnimate.current.style.width = ele.clientWidth + 'px';
        sliderAnimate.current.style.left = ele.offsetLeft + 'px';
      },
      [active]
    );

    const handleExpandIconClick = useCallback(
      root => {
        const index = treeData.findIndex(
          (v: TreeDataProps) => v.Id === root.Id
        );
        console.log(treeData, 'treeData');
        root.expanded = !root.expanded;
        const newTreeData: TreeDataProps[] = JSON.parse(
          JSON.stringify(treeData)
        );
        if (root.expanded) {
          root['Children'].forEach((row: TreeDataProps, i: number) => {
            newTreeData.splice(index + i + 1, 0, row);
          });
        } else {
          newTreeData.splice(index + 1, root['Children'].length);
        }
        setTreeData(newTreeData);
      },
      [treeData]
    );

    const checkboxChange = (
      value: baseType,
      root: TreeDataProps,
      rootIndex: number
    ) => {
      console.log(root);
      const newTreeData = JSON.parse(JSON.stringify(treeData));
      newTreeData[rootIndex].checked = value;
      setTreeData(newTreeData);
    };

    const giftsMapRef: any = useRef({});
    const items = useRef(null);
    const giftRef: any = (ele: HTMLDivElement, index: number) => {
      giftsMapRef.current['tab-item' + index] = ele;
    };
    const sliderAnimate: HTMLDivElement | any = useRef<HTMLDivElement>(null);
    const tabNode = tabs.map((item, index) => {
      return (
        <div
          key={index}
          className={`${styles['pit-tabs-item']} ${
            active === index ? styles['active'] : ''
          } pointer`}
          onClick={() => handleTabClick(index)}
          ref={(ele: HTMLDivElement) => giftRef(ele, index)}
        >
          {item}
        </div>
      );
    });
    const treeNode = treeData.map((root: TreeDataProps, rootIndex: number) => {
      return (
        <div
          ref={items}
          className={styles['e-treeitem']}
          key={root.Id}
          style={{
            marginTop: '12px',
            height: itemSize + 'px',
            lineHeight: itemSize + 'px',
          }}
        >
          <div
            className={styles['e-treeitem_content']}
            style={{ paddingLeft: (root.level - 1) * indent + 'px' }}
          >
            <span
              className={`${styles['treeitem_content_icon']} ${
                root.hasChildren ? '' : styles['is-leaf']
              }`}
            >
              <i
                className={`pitfont ${
                  root.expanded ? 'pit-icon-test12' : 'pit-icon-test1011'
                }`}
                onClick={() => handleExpandIconClick(root)}
              />
              {root.loadStatus ? <i className="icon-e-loading" /> : ''}
            </span>
            <span className={styles['treeitem_checkbox']}>
              <PitCheckbox
                value={root.checked}
                onChange={value => checkboxChange(value, root, rootIndex)}
                style={{
                  visibility: root.isCheckbox ? 'hidden' : 'visible',
                }}
                indeterminate={root.indeterminate}
              />
            </span>
            <span
              className={`pitfont ${styles['folder-icon']} ${
                root.hasChildren ? 'pit-023tuceng' : ''
              } ${!root.hasChildren ? 'pit-wenjian' : ''}`}
            />
            <span
              title={root.text}
              className={`${
                active === root.Id ? styles['active'] : ''
              } treeitem_content_label`}
            >
              {root.text}
            </span>
          </div>
        </div>
      );
    });
    return (
      <div className="flex flex-col" style={{ width: '100%', height: '100%' }}>
        <div className={`${styles['pit-tabs']}`}>
          {tabNode}
          <div
            className={`${styles['pit-slider-animation']}`}
            ref={sliderAnimate}
          />
        </div>

        <div style={{ display: Number(active) === 0 ? '' : 'none' }}>
          <PitSearchInput
            style={{
              marginTop: '12px',
            }}
            placeholder="请输入要搜索的内容"
          />

          {treeNode}
        </div>
      </div>
    );
  }
);
PitModuleTree.defaultProps = {
  itemSize: 22,
  indent: 18,
};
export default PitModuleTree;
